import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { 
  ArrowLeftIcon,
  UserGroupIcon,
  PlusIcon
} from '@heroicons/react/24/outline';
import { LeagueService, TeamService, LeagueSeasonService } from '../../services/firebaseService';
import SeasonTeamsList from '../../components/shared/SeasonTeamsList';

export default function TeamsManagement() {
  const { leagueId, seasonId } = useParams();
  const navigate = useNavigate();
  
  const [league, setLeague] = useState(null);
  const [season, setSeason] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadData();
  }, [leagueId, seasonId]);

  const loadData = async () => {
    try {
      setLoading(true);
      setError('');
      
      // Load league data
      const leagueData = await LeagueService.getLeague(leagueId);
      setLeague(leagueData);
      
      // Load season data
      const seasonData = await LeagueSeasonService.getLeagueSeason(leagueId, seasonId);
      setSeason(seasonData);
      
    } catch (error) {
      console.error('Error loading data:', error);
      setError('Failed to load data');
    } finally {
      setLoading(false);
    }
  };


  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-survivor-500"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Error</h2>
          <p className="text-gray-600 mb-4">{error}</p>
          <button
            onClick={() => navigate(`/manage-leagues/${leagueId}`)}
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-survivor-600 hover:bg-survivor-700"
          >
            <ArrowLeftIcon className="h-4 w-4 mr-2" />
            Back to League
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="px-4 py-6 sm:px-0">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <button
                onClick={() => navigate(`/manage-leagues/${leagueId}`)}
                className="mr-4 p-2 text-gray-400 hover:text-gray-600"
              >
                <ArrowLeftIcon className="w-5 h-5" />
              </button>
              <div>
                <h1 className="text-3xl font-bold text-gray-900">Teams Management</h1>
                <p className="mt-1 text-sm text-gray-500">
                  {league?.name} • Season {seasonId}
                </p>
              </div>
            </div>
            <div className="flex space-x-3">
              <button
                onClick={() => navigate(`/manage-leagues/${leagueId}/teams/${seasonId}/create`)}
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-survivor-600 hover:bg-survivor-700"
              >
                <PlusIcon className="h-4 w-4 mr-2" />
                Add Team
              </button>
            </div>
          </div>
        </div>

        <div className="px-4 py-6 sm:px-0">
          <SeasonTeamsList
            leagueId={leagueId}
            seasonId={seasonId}
            season={season}
            league={league}
            showActions={false}
          />
        </div>
      </div>
    </div>
  );
}
